import he from 'he';

export const extractErrorMessage = errorMessage => {
  const decodedErrorMessage = he.decode(errorMessage);
  const errorText = decodedErrorMessage.replace(/<\/?[^>]+(>|$)/g, '');
  return errorText.trim();
};
